import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';

import {EmailSignatureContainerById} from './email-signature-container-by-user-id';

export function mountEmailSignatureById(userId: string) {
    return () => {
        const emailSignatureContainer = document.querySelector(
            '#react-mount-email-signature-by-id'
        );
        if (emailSignatureContainer) {
            ReactDOM.render(
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <EmailSignatureContainerById userId={userId} />
                    </ReactHooksApolloProvider>
                </ApolloProvider>,
                emailSignatureContainer
            );
        }
    };
}
